import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMillingSm = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 100 100",
	style: { enableBackground: "new 0 0 100 100" },
	xmlSpace: "preserve",
	...props,
	children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("g", {
			style: {},
			children: /* @__PURE__ */ _jsx("path", {
				className: "icon-white",
				d: "M91.9,53c-0.2-0.1-41.8-23.8-41.8-23.8c-0.2-0.1-0.5-0.1-0.7,0L8.1,53c0,0,0,0,0,0 C8.1,53,8,53.1,8,53.1c-0.1,0.1-0.2,0.3-0.2,0.5c0,0,0,0,0,0v11.9c0,0.3,0.1,0.5,0.4,0.6l41.5,24c0,0,0,0,0,0 c0.1,0.1,0.2,0.1,0.4,0.1c0.1,0,0.2,0,0.4-0.1l41.5-24c0.2-0.1,0.4-0.4,0.4-0.6V53.6C92.2,53.4,92.1,53.1,91.9,53z"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-outline",
			d: "M92.2,52.5c-5.9-3.4-32.9-18.8-40.5-23.1c-0.6-0.3-1.4-1-2.2-0.9c-0.6,0.1-1.3,0.6-1.8,0.9 C44.6,31.3,10.3,51,9.1,51.7c-0.5,0.3-1.4,0.7-1.8,1.2c-0.3,0.5-0.2,1.3-0.2,1.8c0,1.1,0,2.2,0,3.2c0,2.3,0,4.6,0,6.9 c0,1,0.3,1.5,1.1,2c1,0.6,1.9,1.1,2.9,1.7c3.7,2.1,27.3,15.8,35.4,20.5c1.3,0.7,2.9,2.2,4.3,1.4c2.5-1.4,38.4-22.1,40.9-23.6 c0.9-0.6,1-1.3,1-2.3c0-2.4,0-4.8,0-7.2C92.8,56.3,93.4,53.2,92.2,52.5z M48.7,78.4v8.9L9.8,64.8v-8.9L48.7,78.4z M36.5,46.8 c2.6-1.5,5.5-0.7,7.8,0.6c2.2,1.3,4.3,2.5,6.5,3.8c6,3.5,12,6.9,18,10.4c1.5,0.9,2.9,1.7,4.4,2.6v1.3L44.6,48.8v0 c-2.6-1.5-6.2-1.6-8.9-0.3C35.2,47.8,35.9,47.1,36.5,46.8z M38.8,50.4c2.1-0.3,3.8,0.3,5.6,1.3c2.1,1.2,4.1,2.4,6.2,3.6 c5.7,3.3,11.5,6.6,17.2,9.9c1.4,0.8,2.8,1.6,4.2,2.4L67.9,70c0-0.9,0.3-2.6-0.7-3.2l0,0L38.8,50.4C38.7,50.4,38.8,50.4,38.8,50.4z  M74.7,61.8c-9.5-5.5-19-10.9-28.4-16.4c-2.4-1.4-4.8-2.4-7.7-2c-2.4,0.3-5.8,1.8-5.6,4.8c0.1,1.5,1.3,2.6,2.5,3.3 c4.6,2.8,9.3,5.4,13.9,8.1c4.9,2.8,9.7,5.6,14.6,8.4l-14,8.1L11.1,53.6l38.6-22.3l38.9,22.4L74.7,61.8z M51.3,78.4l14-8.1 c0,1.4-0.2,4.1,2.1,3.1c1.5-0.7,3-1.7,4.5-2.6c1.1-0.6,2.6-1.2,3.6-2.1c1-0.9,0.5-3.3,0.5-4.6l14.2-8.2v8.9L51.3,87.2V78.4z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M44.8,5.3c-0.7,0-1.2,0.5-1.2,1.2v1.9c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2V6.5 C46,5.8,45.4,5.3,44.8,5.3z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M44.8,39.2c-0.7,0-1.2,0.5-1.2,1.2V44c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2v-3.6 C46,39.8,45.4,39.2,44.8,39.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M44.8,17.9c-0.7,0-1.2,0.5-1.2,1.2v3.6c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2v-3.6 C46,18.4,45.4,17.9,44.8,17.9z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M44.8,25c-0.7,0-1.2,0.5-1.2,1.2v3.6c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2v-3.6 C46,25.5,45.4,25,44.8,25z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M44.8,10.8c-0.7,0-1.2,0.5-1.2,1.2v3.6c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2V12 C46,11.3,45.4,10.8,44.8,10.8z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M44.8,32.1c-0.7,0-1.2,0.5-1.2,1.2v3.6c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2v-3.6 C46,32.6,45.4,32.1,44.8,32.1z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M44.8,46.3c-0.7,0-1.2,0.5-1.2,1.2v1.2L39.7,51l2.4,1.4l0.7-0.4c0.3-0.2,0.8-0.5,0.9-0.5l1.7-1 c0.4-0.2,0.6-0.6,0.6-1v-1.9C46,46.9,45.4,46.3,44.8,46.3z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M36.7,9.9c-0.7,0-1.2,0.5-1.2,1.2v1.9c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2v-1.9 C37.9,10.5,37.4,9.9,36.7,9.9z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M36.7,31.2c-0.7,0-1.2,0.5-1.2,1.2v3.9c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2v-3.9 C37.9,31.7,37.4,31.2,36.7,31.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M36.7,23.5c-0.7,0-1.2,0.5-1.2,1.2v3.9c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2v-3.9 C37.9,24,37.4,23.5,36.7,23.5z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M36.7,15.7c-0.7,0-1.2,0.5-1.2,1.2v3.9c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2v-3.9 C37.9,16.3,37.4,15.7,36.7,15.7z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M36.7,38.9c-0.7,0-1.2,0.5-1.2,1.2V44c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2v-3.9 C37.9,39.5,37.4,38.9,36.7,38.9z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M36.7,46.7c-0.5,0-0.9,0.3-1.1,0.7c0,0,0,0.1-0.1,0.3c0,0.1,0,0.2,0,0.3c0,0,0,0.1,0.1,0.2 c0,0.1,0.1,0.1,0.1,0.2c0.2,0.4,0.6,0.5,1,0.8l1.2,0.7v-2.1C37.9,47.2,37.4,46.7,36.7,46.7z"
		})
	] }) })
});
export default SvgMillingSm;
